module.exports = __webpack_public_path__ + "assets/TriangleByMidpointsDetailed.3c85fd99af3a17d62f755f2933f9135b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TriangleByMidpointsDetailed.png
// module id = 595
// module chunks = 0